import { BaseService, endpoints, http } from '../../../services/base';
import { AccountDto, AccountFilterDto, AccountSearch, FormAccountDto } from '../dto/Account';
import { AttachmentDto } from '../dto/Attachment';

export class AccountService extends BaseService<AccountDto> {
  constructor() {
    super(endpoints.users.default);
  }

  public async findAllAdmin(params?: AccountFilterDto): Promise<AccountSearch> {
    const { data: res } = await http.get(this.url, { params });
    return res;
  }

  public async getAdminDetail(id: string): Promise<AccountDto> {
    const { data: res } = await http.get(this.url + '/' + id);
    return res;
  }

  public async updateAdmin(id: string, body: FormAccountDto): Promise<AccountDto> {
    const { data: res } = await http.patch(this.url + '/' + id, body);
    return res;
  }

  public async updateMe(body: FormAccountDto): Promise<AccountDto> {
    const { data: res } = await http.patch(this.url + '/me', body);
    return res;
  }

  public async postAdmin(body: FormAccountDto): Promise<AccountDto> {
    const { data } = await http.post(this.url, body);
    return data;
  }

  public async uploadFile(data: FormData): Promise<AttachmentDto[]> {
    const { data: res } = await http.postForm(endpoints.attachments.upload, data);
    return res;
  }

  public getFile(id: string): string {
    if (!id) return '';
    return process.env.REACT_APP_API_URL + endpoints.attachments.default + '/' + id + '/download';
  }

  public async findAllResponsibilities(): Promise<any> {
    const { data: res } = await http.get(endpoints.responsibilities.default);
    return res;
  }

  public async deleteAdmin(id: string): Promise<AccountDto> {
    const { data: res } = await http.delete(this.url + '/' + id);
    return res;
  }
}
